import generify from './generic'

export const bundles = generify('experiences-service', 'bundles', 'bundle')
